export const ACTION_CLEAR_COMPANY_BODY = "ACTION_CLEAR_COMPANY_BODY";

export interface ActionClearCompanyBody {
  readonly type: typeof ACTION_CLEAR_COMPANY_BODY;
}

export default (): ActionClearCompanyBody => ({
  type: ACTION_CLEAR_COMPANY_BODY,
});
